import React, { useState } from "react";
import { CircularProgress, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import axios from "axios";
import {AccountInfo, MemberInfo} from "../types/UserInfoTypes";
import config from '../config'
import { Person } from "@material-ui/icons";
import _, { debounce } from "lodash";
import {createDisplayName} from "../utils/formatUtils";

export function UsersPicker(props: {
  onChange: ((picker: AccountInfo | null) => void),
  groupMembers: MemberInfo[],
}): JSX.Element {
  const [loading, setLoading] = useState(false)
  const [options, setOptions] = React.useState<AccountInfo[]>([]);
  const [filterText, setFilterText] = useState("")

  async function fetchPeople(filterText: string) {
    try {
      const urlEndpoint = "app/rest/workflow-users"
      const response = await axios.get(`${config.flowableUiApiBaseUrl}${urlEndpoint}?filter=*${filterText.replaceAll(" ", " *")}`, { withCredentials: true })
      const currentListOfMembers = props.groupMembers.map(e=> e.email);
      let userInfo = []


        const tempData = response.data.data as AccountInfo[]

        const filterValid = (accounts: AccountInfo[]) =>
          accounts.filter(entry => entry.firstName && entry.lastName && entry.email)

        const accountInfo = _.orderBy(filterValid(tempData), [a => a.lastName.toLocaleLowerCase('en'), a => a.firstName.toLocaleLowerCase('en')]);
        userInfo = _.each(accountInfo, acc => acc.displayName = createDisplayName(acc)) as AccountInfo[]

        const filteredUserInfo = userInfo.filter(app => !currentListOfMembers.includes(app.email));

      setOptions(filteredUserInfo);
    } catch (e) {
      console.error(e);
    }
    finally {
      setLoading(false)
    }
  }

  const debouncedSearch =  React.useRef(debounce((filterText) => {
    return fetchPeople(filterText)
  }, 250)).current;

  React.useEffect(() => {
      debouncedSearch(filterText);
  }, [filterText]);

    return (
        <Autocomplete
        onKeyDown={(e) => e.stopPropagation()}
          size="medium"
          id="usersPicker"
          className="usersPickerDiv"
          getOptionSelected={(option, value) => (option && value) ? option.id === value.id : false}
          getOptionLabel={(option) => option?.displayName||''}
          options={options}
          loading={loading}
          onInputChange={(e, val) => {
            setFilterText(val);
          }}
          inputValue={filterText}
          filterOptions={(options) => 
             options.filter(option => {
               if (option === null) {
                 return false;
               }
                 return option?.fullName?.toLowerCase().includes(filterText.toLowerCase())
             })
          }
          onChange={(e, val) => {
            props.onChange(val);
          }}
          disabled={false}
          renderOption={(option: AccountInfo) => <>{
            <span><Person /> {option?.displayName}</span> }</>}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Select a person..."
              variant="outlined"
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <React.Fragment>
                    {loading ? <CircularProgress color="inherit" size={20} /> : null}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                ),
              }}
            />
          )}
        />
      );
  
}
